module.exports = __webpack_public_path__ + "assets/icon-powerSource-power230V.a3ea3189.svg";